module.exports = __webpack_public_path__ + "img/far_day_cyl125_axis90.efae67da.jpg";